<template>
<div class="site-headers yo-fixed-top" style="padding:0;z-index:999;">
   <div class="row el-container" style="background:#fff !important;"> 
      
      <div class="col s6 yo-align-left" style="height:80px;overflow:hidden;">
      
      <div style="color:#5387C5;height:80px;width:280px;" class=" yo-valign-text-center yo-align-center">
         <a href="https://www.innsin.it">
         <div class="yo-text-s">ITALIAN NEONATAL NETWORK</div>
         <div style="line-height:40px;" class="yo-text-5xl yo-text-bold yo-spacing-l">INN<span style="color:#EA6493;display:inline;">SIN</span></div>
         </a>
         
         </div>
      <!--
            <a href="https://www.innsin.it"><img src="../assets/logo.png" style="height:72px;margin-top:4px;margin-left:20px;"/>
         
         </a>
         -->
         </div>
      
      <div class="col s6 yo-align-right" style="height:80px;overflow:hidden;"><a href="https://www.neonatologia.it"><img src="../assets/sin.png" style="height:72px;margin-top:4px;margin-right:20px;"/></a></div>
   </div>
   
   <div class="row  el-container pad-in yo-text-n yo-text-bold" style="height:52px;background: #BDD1E8;">
      <!-- <div class="col s8 m9  yo-valign-text-center" style="height:52px;">INNSIN - Il nuovo network di integrazione tra Italian Neonatal Network e NNSIN (versione {{$teras.version}})</div> -->
      <div class="col s8 m9  yo-valign-text-center" style="height:52px;">{{$centro.profile.row.nome}}<!-- Il nuovo network di integrazione tra Italian Neonatal Network e NNSIN --> (v. {{$teras.version}})</div>

         <div class="col s3 m2m yo-align-right yo-valign-text-center" style="height:52px;"><a href="#" v-on:click.prevent="$teras.app.drawer=true" v-if="$teras.app.auth && typeof $teras.utente!='undefined' && $centro.profile.row.id>0" >{{$teras.utente.nome}} {{$teras.utente.cognome}}</a></div>
         <div class="col s1 mm yo-align-center yo-valign-text-center" style="height:52px;max-width:54px;"><a class="button" href="#" v-on:click.prevent="$teras.app.drawer=true" v-if="$teras.app.auth && typeof $teras.utente!='undefined' && $centro.profile.row.id>0" ><i class="material-icons">menu</i></a></div>

      <!-- <div style="background:red;width:10px;height:40px;"></div> -->
   </div>
   
</div>
</template>


<script>
export default {
  name: 'site-header',
  components: {
     
  }
}
</script>
<style>
#app.device-tablet .site-header{
   
}
.site-header{
   height:212px;
   overflow:hidden;
   
   
   color:#5288C6;
}.site-header > .row > div{
   line-height:52px;    
}.site-header a{
   color:#5288C6;
   display:block;
   
}.site-header a:first{
   border-left:none !important;
}.site-header a.button i, .footer-bottom a.button i{
    line-height: 52px;
    height: 52px;
    font-size: 2.0rem;
    color:#5288C6;
    text-align:left;
}
</style>
